export const TOP_COURSE_GUIDE_STEP_NUMBER = 10000;
